/**
 * A2 · স্বাগত — `/welcome`
 * Frame: `Oprappo P0 Screens.dc.html`, "A2 · স্বাগত".
 *
 * Frame note: "The tagline in Tiro Bangla — the one display use in the whole flow.
 * One sentence names five real services rather than promising an ecosystem."
 *
 * ── W2-12 · THE PLACEHOLDER IS GONE ──────────────────────────────────────────
 *
 * The frame's upper box is a dashed placeholder carrying a designer's note — what the
 * photograph should show and that it has yet to be taken — and the build shipped that
 * note to every new customer as the first thing they read. "Nothing dummy left"
 * (founder, 2026-09-18): the box now holds an in-house illustration (`hero.tsx`) on the
 * same recessed ground, without the dashed placeholder border. The tagline, the sentence
 * under it and both controls are exactly as drawn. Recorded in
 * `docs/deviations/W2-12.md`, A2.
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '@oprappo/ui';
import { Frame, SAND_FRAME } from './frame.js';
import { WelcomeHero } from './hero.js';

export function WelcomeScreen(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Frame className={`${SAND_FRAME} p-[24px]`}>
      <div className="flex-1 min-h-0 bg-sand-deep flex items-center justify-center p-[12px]">
        <WelcomeHero />
      </div>

      <div className="mt-[26px]">
        <h1 className="m-0 font-tiro font-semibold text-[28px] leading-[1.25] text-teal">
          যা ছিল অপ্রাপ্য
          <br />
          তা হোক সহজলভ্য।
        </h1>
        <div className="font-anek font-normal text-[15px] leading-[1.75] text-ink2 mt-[12px]">
          বিল, খাবার, বাজার, রাইড, টেকনিশিয়ান — যা প্রয়োজন, নিজের ভাষায় বলুন।
        </div>
      </div>

      <Button
        tone="primary"
        size="lg"
        className="mt-[24px]"
        onClick={() => navigate('/auth/phone')}
      >
        এগিয়ে যান
      </Button>

      <button
        type="button"
        onClick={() => navigate('/auth/login')}
        className="text-center mt-[15px] font-anek font-medium text-[15px] leading-[1.75] text-link bg-transparent border-0 p-0 rounded-none"
      >
        আমার অ্যাকাউন্ট আছে
      </button>
    </Frame>
  );
}
